import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { validateUserToken } from "../../redux/actions/authActions";

const ProtectedRouteHook = () => {
  const dispatch = useDispatch();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkUser = async () => {
      let user = null;
      try {
        user = JSON.parse(localStorage.getItem("user"));
      } catch (e) {
        user = null;
      }

      // No stored user -> not authenticated
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      // Stored user belongs to another app -> not authenticated, clear it
      if (user?.app !== "family") {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      // Stored user claims to be a family app user, but we must
      // verify against the backend before trusting it (the stored
      // token may be expired/invalid or the user may no longer exist).
      try {
        const result = await dispatch(validateUserToken(user._id));
        const valid = result && result.valid === true;

        if (!valid) {
          localStorage.removeItem("user");
          localStorage.removeItem("token");
        }
        setIsAdmin(valid);
      } catch (e) {
        // Backend could not be reached (network/endpoint error).
        // Fail-open: keep the session based on the "family" app field
        // so that a backend outage never breaks a legitimate login.
        setIsAdmin(true);
      } finally {
        setLoading(false);
      }
    };

    checkUser();
  }, [dispatch]);

  return [isAdmin, loading];
};

export default ProtectedRouteHook;
